import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const zip = (first, second, resultSelector) => {
    if (resultSelector) {
        return zip2(first, second, resultSelector);
    }
    else {
        return zip1(first, second);
    }
};
const zip1 = (source, second) => {
    async function* iterator() {
        const firstIterator = source[Symbol.asyncIterator]();
        const secondIterator = second[Symbol.asyncIterator]();
        while (true) {
            const [a, b] = await Promise.all([firstIterator.next(), secondIterator.next()]);
            if (a.done || b.done) {
                break;
            }
            else {
                yield [a.value, b.value];
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
const zip2 = (source, second, resultSelector) => {
    async function* iterator() {
        const firstIterator = source[Symbol.asyncIterator]();
        const secondIterator = second[Symbol.asyncIterator]();
        while (true) {
            const [a, b] = await Promise.all([firstIterator.next(), secondIterator.next()]);
            if (a.done || b.done) {
                break;
            }
            else {
                yield resultSelector(a.value, b.value);
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
